import React, { Suspense } from "react";
import { updateActiveUserTime } from "../../custom_functions/Functions.jsx";
// import $ from "jquery";
// import { isMultitenant } from "../../custom_functions/Constance.jsx";
const Help = React.lazy(() => import('../../custom_modules/Help.jsx'));

class PHelp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            data: this.props.location,

        }
    }


    componentDidMount() {
updateActiveUserTime();
    }

    onrRdirectnode(nodecode) {

        this.props.history.push("/help#" + nodecode)
    }
    onPushSuccess(response) {
        // store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => { this.props.history.push("/help"); }, 100);
    }

    render() {
//  if (!$.session.get("User")) {
//       setTimeout(() => {
//         let tenantdomain= $.session.get("tenantdomain");

//         if(tenantdomain !== undefined){
//                 isMultitenant === 0
//                 ? this.props.history.push("/")
//                 : this.props.history.push("/#" + tenantdomain);
              
//               }else{
//                 this.props.history.push("/")
//               }
//       }, 100);
//       return <div></div>;
//     }
        return (
            <Suspense fallback={<div></div>}>
                <Help values={this.state.data} onChildnodeClick={this.onrRdirectnode.bind(this)} onPush={this.onPushSuccess.bind(this)} />
            </Suspense>
        );
    }
}
export default PHelp;

